import { ids } from "@icarros/theme-react";
import { Contrast } from "../../../types/general.types";
import styled, { css } from "styled-components";
import { SearchInputVariants, } from "./constants";
import { hexToRgba } from "@icarros/utils-react";
const { color, text, size, opacity } = ids || {};
const defaultContainer = css `
  background-color: ${color.backgrounds.ids_color_bg_variant_01};
  border-color: ${color.border.ids_color_border_medium};
`;
const primaryDarkContainer = css `
  background-color: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_medium)};
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium)};
`;
const secondaryDarkContainer = css `
  background-color: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_soft)};
  border-color: ${hexToRgba(color.contrast.ids_color_contrast_onDark, opacity.ids_opacity_medium)};
`;
const defaultInput = css `
  color: ${color.action.neutral.ids_color_action_neutral_base};
  caret-color: ${color.action.primary.ids_color_action_primary_base};
`;
const darkInput = css `
  color: ${color.contrast.ids_color_contrast_onBrand_primary};
  caret-color: ${color.contrast.ids_color_contrast_onBrand_primary};
`;
const getInputStyle = (contrast) => {
    switch (contrast) {
        case Contrast.dark:
            return darkInput;
        default:
            return defaultInput;
    }
};
const getContainerStyle = (contrast, variant) => {
    switch (contrast) {
        case Contrast.dark:
            return variant === SearchInputVariants.secondary
                ? secondaryDarkContainer
                : primaryDarkContainer;
        default:
            return defaultContainer;
    }
};
export const StyledInput = styled.input `
  display: flex;
  text-shadow: none;
  border: 0 none;
  flex: 1 1 auto;
  background: transparent;
  ${text.label.ids_textStyle_label_medium_regular};
  ${({ contrast }) => getInputStyle(contrast)}
  padding: 0 ${size.general.ids_size_general_4x} 0 ${size.general
    .ids_size_general_8x};
  &:focus {
    outline: 0;
  }
`;
export const SearchInputContainer = styled.div `
  border-radius: ${size.corner_radius.ids_size_cornerRadius_button};
  border-width: ${size.border_width.ids_size_border_small};
  border-style: solid;
  height: ${size.general.ids_size_general_48x};
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  padding: 0 0 0 ${size.general.ids_size_general_16x};
  ${({ contrast, variant }) => getContainerStyle(contrast, variant)}
`;
//# sourceMappingURL=SearchInput.style.js.map